import React from 'react';
import { Transition } from 'react-transition-group';
const ENTER_DURATION = 120;
const EXIT_DURATION = 80;
const easing = 'cubic-bezier(0.23, 1, 0.32, 1)'; // easeOutQuint
const defaultStyle = (timeout) => ({
    transition: `transform ${timeout.enter}ms ${easing}, opacity ${timeout.enter}ms linear`,
    opacity: 0,
});
const transitionStyle = (state) => {
    const transitions = {
        entering: {},
        entered: {
            opacity: 1,
        },
        exiting: {
            opacity: 0,
        },
    };
    return transitions[state];
};
const getStyle = (timeout, state) => () => ({
    ...defaultStyle(timeout),
    ...transitionStyle(state),
});
const Animation = ({ children, immediatelyHide, immediatelyShow, onExited, in: inProp, }) => {
    const timeout = {
        enter: immediatelyShow ? 0 : ENTER_DURATION,
        exit: immediatelyHide ? 0 : EXIT_DURATION,
    };
    return (React.createElement(Transition, { timeout: timeout, in: inProp, onExited: onExited, unmountOnExit: true, appear: true }, (state) => children(getStyle(timeout, state))));
};
export default Animation;
//# sourceMappingURL=Animation.js.map